/**
 * Environment configuration
 * Centralized access to environment variables
 */

export const env = {
  // API Configuration
  apiUrl: import.meta.env.VITE_API_URL || 'http://localhost:3000/api',
  
  // App Configuration
  appName: import.meta.env.VITE_APP_NAME || 'PureAum',
  appVersion: import.meta.env.VITE_APP_VERSION || '0.1.0',
  
  // Environment
  isDevelopment: import.meta.env.DEV,
  isProduction: import.meta.env.PROD,
  
  // Feature Flags
  enableAnalytics: import.meta.env.VITE_ENABLE_ANALYTICS === 'true',
  enableBlockchainVerification: import.meta.env.VITE_ENABLE_BLOCKCHAIN === 'true',
} as const;

// Validate required environment variables
const requiredEnvVars = ['VITE_API_URL'];

if (env.isProduction) {
  requiredEnvVars.forEach((varName) => {
    if (!import.meta.env[varName]) {
      console.error(`Missing required environment variable: ${varName}`);
    }
  });
}
